import { control } from '@reactables/forms';
import { FormBuilders } from '@jauntin/reactables';

const RxSamplePolicyDocument = () =>
  FormBuilders.build(control([null]), { name: 'rxSamplePolicyForm' });

export default RxSamplePolicyDocument;
